var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUdemy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.157 0h148.6C242.908 0 256 13.092 256 29.243v146.314C256 219.983 219.983 256 175.557 256H80.105C35.865 256 0 220.134 0 175.895V78.157C0 34.99 34.99 0 78.157 0",
    fill: "#4FB74C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 48.64v99.22c0 32.86-26.64 59.5-59.5 59.5h-32.74c-33.889 0-61.36-27.471-61.36-61.358V75.384c0-14.77 11.973-26.744 26.744-26.744h9.096v96.466c0 16.002 12.972 28.974 28.974 28.974h24.266c15.839 0 28.68-12.841 28.68-28.68V74.947c0-14.528 11.779-26.307 26.307-26.307h9.533",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdemy);
export default __webpack_public_path__ + "static/media/udemy.9c48ae2ba325448fcbd1e8542859b3c6.svg";
export { ForwardRef as ReactComponent };